import colorModel from './colorModel.vue';
export default {
  components: {
    colorModel
  },
  props: {
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    },
    pageTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      form: {
        invoiceConfig: {
          maxSelect: ''
        }
      },
      colorShow: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.form = this.styleObj;
    });
  },
  methods: {
    changeFun() {
      this.$emit('itemChange', this.form);
    },
    colorClickFun(val, key) {
      this.colorShow = true;
      this.$nextTick(() => {
        this.$refs.colorRef.init(val, key);
      });
    },
    colorFun(val, key) {
      this.form.buttonInfo.buttons[0][key] = val;
      this.changeFun();
      this.colorShow = false;
    }
  }
};